import { API_URL } from 'constants/env'

export const getGetApiKeysUrl = (bubbleAppId: string | number): URL => {
  const url = `${API_URL}/bubbleApp/${bubbleAppId}/apiKeys`
  return new URL(url)
}
